import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseScrollDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMouseScrollDown"><Path d="M15 20.25L13.1094 21.5104C12.4376 21.9583 11.5624 21.9583 10.8906 21.5104L9 20.25M12 5.75V8.25M12 17.25C9.10051 17.25 6.75 14.8995 6.75 12V7C6.75 4.1005 9.10051 1.75 12 1.75C14.8995 1.75 17.25 4.10051 17.25 7V12C17.25 14.8995 14.8995 17.25 12 17.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMouseScrollDown;
